import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import { cloneDeepObject, handleSectionTemplate } from '@/views/website/products/components/description/common/utils';

export const buildBannerB1 = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const blockSignal = suggestionFields.blocks || [];

  const titleBanner = blockSignal
    .map(item => {
      if (item.block_type === 'body_text') {
        return `<p>${item.text}</p>`;
      }
      if (item.block_type === 'heading') {
        return `<h2>${item.text}</h2>`;
      }
      return null;
    })
    .filter(Boolean)
    .join('');

  const buttonCta = suggestionFields.blocks?.find(item => item.block_type === 'cta')?.cta_items?.[0];

  const fieldUpdate = {
    title: 'Hero banner b1',
    enableAnchor: false,
    contentAlign: 'left',
    padding: {
      top: true,
      bottom: true,
    },
    background: {
      color: '#ffffff',
      img: suggestionFields.layout?.background_media?.url,
      imgMobile: suggestionFields.layout?.background_media?.url,
    },
    titleBanner: {
      show: !!titleBanner,
      text: titleBanner,
    },
    contentBanner: {
      show: false,
      text: '',
    },
    button: {
      show: !!buttonCta,
      text: buttonCta?.label,
      link: '',
      color: '#ffffff',
      background: '#3b82f6',
      subButton: '',
    },
    rating: {
      show: false,
      value: 5,
      text: '',
    },
    tag: {
      show: false,
      text: '',
    },
    features: {
      show: false,
      items: [],
    },
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionBannerB1(newSection.html, fieldUpdate),
  };
};

export const buildCardBannerRivoneedSection = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const bannerFallback = 'https://cdn.skyfastimg.com/images/2026/07/16/image-6a58931fab9e2f19c0364b90.png';

  const blockSignal = suggestionFields.blocks || [];

  const titleBanner = blockSignal
    .map(item => {
      if (item.block_type === 'body_text') {
        return `<p>${item.text}</p>`;
      }
      if (item.block_type === 'heading') {
        return `<h2>${item.text}</h2>`;
      }
      return null;
    })
    .filter(Boolean)
    .join('');

  const promoPill = blockSignal?.find(item => item.block_type === 'promo_pill')?.promo_pill_data?.text || '';

  const iconGridItems = blockSignal
    ?.find(item => item.block_type === 'icon_grid')
    ?.icon_grid_items?.map(item => {
      return {
        text: item.title,
        icon: item.icon_url,
      };
    });

  const buttonCta = blockSignal?.find(item => item.block_type === 'cta')?.cta_items?.[0];

  const fieldUpdate = {
    title: 'Banner Rivoneed 1212',
    enableAnchor: false,
    bannerImage: {
      useBannerMobile: false,
      bannerDesktop: suggestionFields.layout?.background_media?.url || bannerFallback,
    },
    wrapContent: {
      widthContent: 650,
      paddingTop: 0,
      paddingBottom: 0,
    },
    tags: {
      show: !!promoPill,
      borderRadius: 10,
      backgroundColorTag: '#ffffff23',
      textColorTag: '#ffffff',
      borderColor: '#ffffff',
      items: [
        {
          text: promoPill,
        },
      ],
    },
    textContent: {
      show: !!titleBanner,
      content: titleBanner,
    },
    pills: {
      show: !!iconGridItems,
      background: '#ffffff',
      color: '#000000',
      items: iconGridItems || [],
    },
    button: {
      show: !!buttonCta,
      link: '#',
      backgroundColor: '#606F99',
      color: '#fff',
      radius: 10,
      text: buttonCta?.label || '',
      iconPrefix: {
        show: false,
        src: '',
      },
      iconSuffix: {
        show: false,
        src: '',
      },
      subBtn: {
        show: false,
        text: '',
      },
    },
    rating: {
      show: true,
      value: 5,
      text: '',
    },
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCardBannerRivoneed(newSection.html, fieldUpdate),
  };
};

export const buildCardsectionCardBanner02Rivoneed = (baseTemplate, suggestionFields) => {
  const newSection = handleSectionTemplate.insertNewId(cloneDeepObject(baseTemplate));
  if (!newSection?.html) return null;

  const imageBanner = suggestionFields.layout?.background_media?.url;

  const heading = (suggestionFields.blocks || [])
    .map(item => {
      if (item.block_type === 'heading') {
        return `<h2>${item.text}</h2>`;
      }
      return null;
    })
    .filter(Boolean)
    .join('');

  const description = (suggestionFields.blocks || [])
    .map(item => {
      if (item.block_type === 'body_text') {
        return `<p>${item.text}</p>`;
      }
      return null;
    })
    .filter(Boolean)
    .join('');

  const fieldUpdate = {
    title: 'Banner Rivoneed 02',
    banner: {
      useBannerMobile: false,
      desktop: imageBanner,
    },
    heading: {
      show: !!heading,
      content: heading,
    },
    description: {
      show: !!description,
      content: description,
    },
    divider: {
      show: true,
      align: 'left',
    },
  };

  return {
    ...newSection,
    title: fieldUpdate.title,
    html: updateHtmlFromData.sectionCardBanner02Rivoneed(newSection.html, fieldUpdate),
  };
};
